// TODO: REMOVE & REPLACE ALL USAGES WITH NEW EVENT METHODS
import * as Models from "../.";
export class CustomerEventMap {
  associatedEpcCalculation: Models.Customer.CustomerEvent.ICustomerEvent;
  associatedRegion: Models.Customer.CustomerEvent.ICustomerEvent;
  autoPaymentAuthorization: Models.Customer.CustomerEvent.ICustomerEvent;
  creditAuthSigned: Models.Customer.CustomerEvent.ICustomerEvent;
  creditCheck: Models.Customer.CustomerEvent.ICustomerEvent;
  electronicConsentSigned: Models.Customer.CustomerEvent.ICustomerEvent;
  hasNonTerminalEnvelopes: Models.Customer.CustomerEvent.ICustomerEvent;
  hasNonTerminalContractEnvelopes: Models.Customer.CustomerEvent.ICustomerEvent;
  paymentCapture: Models.Customer.CustomerEvent.ICustomerEvent;
  paymentInformationReceived: Models.Customer.CustomerEvent.ICustomerEvent;
  contractSigned: Models.Customer.CustomerEvent.ICustomerEvent;
  pto: Models.Customer.CustomerEvent.ICustomerEvent;
  salesforceId: Models.Customer.CustomerEvent.ICustomerEvent;
  scheduleA1: Models.Customer.CustomerEvent.ICustomerEvent;
  systemMon: Models.Customer.CustomerEvent.ICustomerEvent;
  titleValidation: Models.Customer.CustomerEvent.ICustomerEvent;
  utilityBillUpload: Models.Customer.CustomerEvent.ICustomerEvent;
  welcomeLetterSent: Models.Customer.CustomerEvent.ICustomerEvent;
}
